const ReactGA = require('react-ga');
const { isStagingEnv } = require('./src/commons/utils');

if (!isStagingEnv()) {
  ReactGA.initialize('UA-169617336-2');
  exports.onRouteUpdate = (state, page, pages) => {
    ReactGA.pageview(state.location.pathname);
  };
}
